import React from 'react'

import {SvgIcon, SvgIconProps} from './SvgIcon'

const DeliveryBadgeIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props}>
    <path
      d="M7.86667 10.7333L3.8 6.33333C3.6 6.26667 1.8 9.26667 2.33333 9.8C2.73333 10.2 8.4 14.0667 8.4 14.0667L7.86667 10.7333Z"
      fill="#C4C2BE"
    />
    <path d="M15.8 6.26667L17 15.3333C15.7333 15.5333 12.1333 16.2 9.8 16.2C9.46667 16.2 9.2 16.2 8.93333 16.1333C8.13333 13.0667 7.8 10.4 7.86667 7.93333C8.6 7.73333 9.33333 7.6 10.0667 7.4C12 6.86667 13.9333 6.33333 15.8 6.26667ZM16.2 5.73333C13.3333 5.8 10.4 6.8 7.26667 7.46667C7.13333 10.3333 7.6 13.3333 8.46667 16.5333C8.8 16.6 9.26667 16.6 9.73333 16.6C12.6667 16.6 17.4667 15.6667 17.4667 15.6667L16.2 5.73333Z" />
    <path d="M21 6.13333C21.8667 8.93333 22.2 11.5333 22.0667 14.1333C21.9333 14.2 21.8 14.2 21.6667 14.2667C20.2 14.7333 19.0667 15.1333 17.5333 15.2667L16.2 6.26667C17.1333 6.2 18.0667 6.2 19.2 6.2C19.8 6.2 20.3333 6.13333 21 6.13333ZM21.3333 5.66667C19.0667 5.73333 17.2667 5.6 15.6667 5.86667L17.0667 15.8C19.1333 15.7333 20.5333 15.2 22.5333 14.5333C22.7333 11.4667 22.3333 8.66667 21.3333 5.66667Z" />
    <path
      d="M15.8 12.1333L13.2 12.9333L12.4667 10.6L15.0667 9.8L15.8 12.1333Z"
      fillOpacity={0}
      stroke="#231F20"
      strokeWidth="0.3718"
    />
    <path d="M12.3333 6L10.3333 6.33333L11.3333 16.6667L13.6667 16.3333L12.3333 6Z" fill="#E0DEDA" />
    <path
      d="M20.8667 15.3333L20.0667 15.5333C20 15.5333 19.8667 15.4667 19.8667 15.4L18.6 5.86667C18.6 5.66667 18.7333 5.46667 18.9333 5.46667H19.4C19.6 5.46667 19.7333 5.6 19.7333 5.8L20.9333 15.1333C20.9333 15.2667 20.9333 15.3333 20.8667 15.3333Z"
      fill="#E0DEDA"
    />
    <path
      d="M3.4 16.8C3.4 16.8 9.8 18.9333 11.5333 18.8667C13.3333 18.7333 12.2 18.8 14.8 17.7333C18.2667 16.3333 17.1333 15.7333 17.1333 15.7333L13.1333 16.3333C13.1333 16.3333 12.5333 16.2 13.4 15.0667C14.2 13.9333 12.6 12.9333 12.5333 13.8C12.4667 14.6667 11.8 15.0667 11.8 15.0667C11.8 15.0667 11.0667 15.5333 10.4 16.1333C9.8 16.6 2 11.8667 2 11.8667C1.86667 12.7333 2.06667 16.4667 3.4 16.8Z"
      fill="#C4C2BE"
    />
    <path d="M20.8667 16.6667C19.2 19.8 15.8667 22 12.0667 22C6.46667 22 2 17.5333 2 12C2 6.46667 6.46667 2 12 2C14.3333 2 16.5333 2.8 18.2 4.2C18.5333 4.2 18.8667 4.2 19.2 4.2C17.3333 2.4 14.8 1.33333 12 1.33333C6.13333 1.33333 1.33333 6.13333 1.33333 12C1.33333 17.8667 6.13333 22.6667 12 22.6667C16.3333 22.6667 20 20.1333 21.6667 16.4C21.4 16.5333 21.1333 16.6 20.8667 16.6667Z" />
  </SvgIcon>
)

export default DeliveryBadgeIcon
